import styles from "./Card.module.sass";

interface CardProps {
  adminInfo: StudentLicenseInfo;
}

export const Card = ({ adminInfo }: CardProps) => {
  return (
    <div className={styles.Card}>
      <p>
        <b>{adminInfo.name}</b> {adminInfo.email}
        <span>Admin</span>
      </p>
      <p>
        Permisos: <b>Configuración de la cuenta, Reportes, Licencias, Equipos, Rutas.</b>
      </p>
    </div>
  );
};
